/**
 * 댓글 노출 요청 스토어 (JCG-3601) — 순수 모듈.
 *
 * 댓글 딥링크 훅(`useCommentDeepLink`)은 `location.hash` 변화로만 대상 댓글을 화면에 올린다. 해시가 이미 같은 값이면
 * (알림 벨에서 같은 알림을 다시 누른 경우) `hashchange` 가 나지 않아 아무 일도 안 하므로, "지금 이 댓글을 다시
 * 보여 달라" 는 명시적 요청을 별도 신호(nonce)로 전달한다. 해시가 SSOT 이고, 요청 id 가 현재 해시와 다르면 훅이 무시한다.
 */

export interface CommentRevealRequest {
  id: string;
  /** 요청마다 증가 — 같은 id 를 다시 요청해도 훅의 의존성이 바뀌게 한다 */
  nonce: number;
}

let current: CommentRevealRequest | null = null;
let counter = 0;
const listeners = new Set<() => void>();

export function requestCommentReveal(commentId: string): void {
  counter += 1;
  current = { id: commentId, nonce: counter };
  listeners.forEach((listener) => listener());
}

export function subscribeCommentReveal(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getCommentRevealSnapshot(): CommentRevealRequest | null {
  return current;
}

export function getCommentRevealServerSnapshot(): CommentRevealRequest | null {
  return null;
}
